import React from 'react';
import DiscoverUser from 'modules/discover/mobile/discoverUser.component';
import { BodyText } from 'modules/styled';

export const renderHeader = (): JSX.Element => {
  return (
    <BodyText>
      These users have used the same IP address. A few users may be normal, but many may
      be multiple account or proxy users.
    </BodyText>
  );
};

export const renderRow = (user: any): JSX.Element => {
  return (
    <DiscoverUser
      user={{
        ...user,
      }}
      renderRight={() => null}
      showRelevance
    />
  );
};
